// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3kMaE","requiredAsterisk":"Info_requiredAsterisk__2AZiA"};